import { StickerFrame, type StickerArtProps } from './StickerFrame';

export function Weather(props: StickerArtProps) {
  return (
    <StickerFrame background="#38bdf8" {...props}>
      <circle cx="40" cy="24" r="9" fill="#facc15" />
      <circle cx="22" cy="40" r="8" fill="#ffffff" />
      <circle cx="32" cy="34" r="10" fill="#ffffff" />
      <circle cx="43" cy="40" r="8" fill="#ffffff" />
      <rect x="22" y="38" width="21" height="10" fill="#ffffff" />
    </StickerFrame>
  );
}
